module.exports = __webpack_public_path__ + "web/img/login-com-bg.1f16a1a3.svg";